const getStrapiUrl = () =>
  process.env.NODE_ENV === "production"
    ? process.env.REACT_APP_PROD_URL
    : process.env.REACT_APP_LOCAL_URL;

const getStrapiApiToken = () =>
  process.env.NODE_ENV === "production"
    ? process.env.REACT_APP_PROD_STRAPI_API_TOKEN
    : process.env.REACT_APP_STRAPI_API_TOKEN;

export { getStrapiApiToken };
export default getStrapiUrl;
